import { useSelector } from 'react-redux'

import * as Sentry from '@sentry/react'

function useLogger() {
  const unitSelected = useSelector(state => state.unitSelected)
  const user = useSelector(state => state.user)
  // Check if unitSelected is defined before accessing its data property
  const currentUnit = unitSelected ? unitSelected.data : 'no unit selected'
  // Check if user and user.profile are defined before accessing profile
  const userProfile = user && user.profile ? user.profile : 'no user'

  const log = (level, type, message, extra = {}) => {
    try {
      const allowedLevels = ['info', 'warn', 'error', 'success']
      const allowedTypes = [
        'navigate_to',
        'click',
        'create_item',
        'update_item',
        'delete_item',
        'component',
      ]
      if (!allowedLevels.includes(level)) {
        throw new Error('Invalid log level')
      }
      if (!allowedTypes.includes(type)) {
        throw new Error('Invalid log type')
      }
      if (typeof message !== 'string') {
        console.error(message)
        throw new Error('Invalid log message', message)
      }
      const client = userProfile?.cliCode
      const userLogin = userProfile?.usu_login
      const unit = currentUnit

      Sentry.addBreadcrumb({
        message,
        category: type,
        level,
        data: {
          user: userLogin,
          client,
          unit,
          extra,
          view: {
            url_details: {
              path: window.location.pathname,
              scheme: window.location.protocol.replace(':', ''),
              port:
                window.location.port ||
                (window.location.protocol === 'https:' ? 443 : 80),
              host: window.location.hostname,
            },
            url: window.location.href,
          },
        },
      })
    } catch (error) {
      console.error(error)
    }
  }
  return {
    info: (type, message, extra) => log('info', type, message, extra),
    warn: (type, message, extra) => log('warn', type, message, extra),
    error: (type, message, extra) => log('error', type, message, extra),
  }
}

export default useLogger
